/**
 * Application logger — replaces raw console.* calls.
 * In production, only warnings and errors are emitted.
 */
const IS_DEV = process.env.NODE_ENV !== 'production';

const logger = {
  debug: (...args) => IS_DEV && console.debug('[app]', ...args),
  info: (...args) => IS_DEV && console.log('[app]', ...args),
  warn: (...args) => console.warn('[app]', ...args),
  error: (...args) => console.error('[app]', ...args),
};

export default logger;
